var map = {
	"./square/ac.svg": 1743,
	"./square/ad.svg": 1744,
	"./square/ae.svg": 1745,
	"./square/af.svg": 1746,
	"./square/ag.svg": 1747,
	"./square/ai.svg": 1748,
	"./square/al.svg": 1749,
	"./square/am.svg": 1750,
	"./square/ao.svg": 1751,
	"./square/aq.svg": 1752,
	"./square/ar.svg": 1753,
	"./square/as.svg": 1754,
	"./square/at.svg": 1755,
	"./square/au.svg": 1756,
	"./square/aw.svg": 1757,
	"./square/ax.svg": 1758,
	"./square/az.svg": 1759,
	"./square/ba.svg": 1760,
	"./square/bb.svg": 1761,
	"./square/bd.svg": 1762,
	"./square/be.svg": 1763,
	"./square/bf.svg": 1764,
	"./square/bg.svg": 1765,
	"./square/bh.svg": 1766,
	"./square/bi.svg": 1767,
	"./square/bj.svg": 1768,
	"./square/bl.svg": 1769,
	"./square/bm.svg": 1770,
	"./square/bn.svg": 1771,
	"./square/bo.svg": 1772,
	"./square/bq.svg": 1773,
	"./square/br.svg": 1774,
	"./square/bs.svg": 1775,
	"./square/bt.svg": 1776,
	"./square/bv.svg": 1777,
	"./square/bw.svg": 1778,
	"./square/by.svg": 1779,
	"./square/bz.svg": 1780,
	"./square/ca.svg": 1781,
	"./square/cc.svg": 1782,
	"./square/cd.svg": 1783,
	"./square/cefta.svg": 1784,
	"./square/cf.svg": 1785,
	"./square/cg.svg": 1786,
	"./square/ch.svg": 1787,
	"./square/ci.svg": 1788,
	"./square/ck.svg": 1789,
	"./square/cl.svg": 1790,
	"./square/cm.svg": 1791,
	"./square/cn.svg": 1792,
	"./square/co.svg": 1793,
	"./square/cp.svg": 1794,
	"./square/cr.svg": 1795,
	"./square/cu.svg": 1796,
	"./square/cv.svg": 1797,
	"./square/cw.svg": 1798,
	"./square/cx.svg": 1799,
	"./square/cy.svg": 1800,
	"./square/cz.svg": 1801,
	"./square/de.svg": 1802,
	"./square/dg.svg": 1803,
	"./square/dj.svg": 1804,
	"./square/dk.svg": 1805,
	"./square/dm.svg": 1806,
	"./square/do.svg": 1807,
	"./square/dz.svg": 1808,
	"./square/ea.svg": 1809,
	"./square/ec.svg": 1810,
	"./square/ee.svg": 1811,
	"./square/eg.svg": 1812,
	"./square/eh.svg": 1813,
	"./square/er.svg": 1814,
	"./square/es-ct.svg": 1815,
	"./square/es-ga.svg": 1816,
	"./square/es.svg": 1817,
	"./square/et.svg": 1818,
	"./square/eu.svg": 1819,
	"./square/fi.svg": 1820,
	"./square/fj.svg": 1821,
	"./square/fk.svg": 1822,
	"./square/fm.svg": 1823,
	"./square/fo.svg": 1824,
	"./square/fr.svg": 1825,
	"./square/ga.svg": 1826,
	"./square/gb-eng.svg": 1827,
	"./square/gb-nir.svg": 1828,
	"./square/gb-sct.svg": 1829,
	"./square/gb-wls.svg": 1830,
	"./square/gb.svg": 1831,
	"./square/gd.svg": 1832,
	"./square/ge.svg": 1833,
	"./square/gf.svg": 1834,
	"./square/gg.svg": 1835,
	"./square/gh.svg": 1836,
	"./square/gi.svg": 1837,
	"./square/gl.svg": 1838,
	"./square/gm.svg": 1839,
	"./square/gn.svg": 1840,
	"./square/gp.svg": 1841,
	"./square/gq.svg": 1842,
	"./square/gr.svg": 1843,
	"./square/gs.svg": 1844,
	"./square/gt.svg": 1845,
	"./square/gu.svg": 1846,
	"./square/gw.svg": 1847,
	"./square/gy.svg": 1848,
	"./square/hk.svg": 1849,
	"./square/hm.svg": 1850,
	"./square/hn.svg": 1851,
	"./square/hr.svg": 1852,
	"./square/ht.svg": 1853,
	"./square/hu.svg": 1854,
	"./square/ic.svg": 1855,
	"./square/id.svg": 1856,
	"./square/ie.svg": 1857,
	"./square/il.svg": 1858,
	"./square/im.svg": 1859,
	"./square/in.svg": 1860,
	"./square/io.svg": 1861,
	"./square/iq.svg": 1862,
	"./square/ir.svg": 1863,
	"./square/is.svg": 1864,
	"./square/it.svg": 1865,
	"./square/je.svg": 1866,
	"./square/jm.svg": 1867,
	"./square/jo.svg": 1868,
	"./square/jp.svg": 1869,
	"./square/ke.svg": 1870,
	"./square/kg.svg": 1871,
	"./square/kh.svg": 1872,
	"./square/ki.svg": 1873,
	"./square/km.svg": 1874,
	"./square/kn.svg": 1875,
	"./square/kp.svg": 1876,
	"./square/kr.svg": 1877,
	"./square/kw.svg": 1878,
	"./square/ky.svg": 1879,
	"./square/kz.svg": 1880,
	"./square/la.svg": 1881,
	"./square/lb.svg": 1882,
	"./square/lc.svg": 1883,
	"./square/li.svg": 1884,
	"./square/lk.svg": 1885,
	"./square/lr.svg": 1886,
	"./square/ls.svg": 1887,
	"./square/lt.svg": 1888,
	"./square/lu.svg": 1889,
	"./square/lv.svg": 1890,
	"./square/ly.svg": 1891,
	"./square/ma.svg": 1892,
	"./square/mc.svg": 1893,
	"./square/md.svg": 1894,
	"./square/me.svg": 1895,
	"./square/mf.svg": 1896,
	"./square/mg.svg": 1897,
	"./square/mh.svg": 1898,
	"./square/mk.svg": 1899,
	"./square/ml.svg": 1900,
	"./square/mm.svg": 1901,
	"./square/mn.svg": 1902,
	"./square/mo.svg": 1903,
	"./square/mp.svg": 1904,
	"./square/mq.svg": 1905,
	"./square/mr.svg": 1906,
	"./square/ms.svg": 1907,
	"./square/mt.svg": 1908,
	"./square/mu.svg": 1909,
	"./square/mv.svg": 1910,
	"./square/mw.svg": 1911,
	"./square/mx.svg": 1912,
	"./square/my.svg": 1913,
	"./square/mz.svg": 1914,
	"./square/na.svg": 1915,
	"./square/nc.svg": 1916,
	"./square/ne.svg": 1917,
	"./square/nf.svg": 1918,
	"./square/ng.svg": 1919,
	"./square/ni.svg": 1920,
	"./square/nl.svg": 1921,
	"./square/no.svg": 1922,
	"./square/np.svg": 1923,
	"./square/nr.svg": 1924,
	"./square/nu.svg": 1925,
	"./square/nz.svg": 1926,
	"./square/om.svg": 1927,
	"./square/pa.svg": 1928,
	"./square/pe.svg": 1929,
	"./square/pf.svg": 1930,
	"./square/pg.svg": 1931,
	"./square/ph.svg": 1932,
	"./square/pk.svg": 1933,
	"./square/pl.svg": 1934,
	"./square/pm.svg": 1935,
	"./square/pn.svg": 1936,
	"./square/pr.svg": 1937,
	"./square/ps.svg": 1938,
	"./square/pt.svg": 1939,
	"./square/pw.svg": 1940,
	"./square/py.svg": 1941,
	"./square/qa.svg": 1942,
	"./square/re.svg": 1943,
	"./square/ro.svg": 1944,
	"./square/rs.svg": 1945,
	"./square/ru.svg": 1946,
	"./square/rw.svg": 1947,
	"./square/sa.svg": 1948,
	"./square/sb.svg": 1949,
	"./square/sc.svg": 1950,
	"./square/sd.svg": 1951,
	"./square/se.svg": 1952,
	"./square/sg.svg": 1953,
	"./square/sh.svg": 1954,
	"./square/si.svg": 1955,
	"./square/sj.svg": 1956,
	"./square/sk.svg": 1957,
	"./square/sl.svg": 1958,
	"./square/sm.svg": 1959,
	"./square/sn.svg": 1960,
	"./square/so.svg": 1961,
	"./square/sr.svg": 1962,
	"./square/ss.svg": 1963,
	"./square/st.svg": 1964,
	"./square/sv.svg": 1965,
	"./square/sx.svg": 1966,
	"./square/sy.svg": 1967,
	"./square/sz.svg": 1968,
	"./square/ta.svg": 1969,
	"./square/tc.svg": 1970,
	"./square/td.svg": 1971,
	"./square/tf.svg": 1972,
	"./square/tg.svg": 1973,
	"./square/th.svg": 1974,
	"./square/tj.svg": 1975,
	"./square/tk.svg": 1976,
	"./square/tl.svg": 1977,
	"./square/tm.svg": 1978,
	"./square/tn.svg": 1979,
	"./square/to.svg": 1980,
	"./square/tr.svg": 1981,
	"./square/tt.svg": 1982,
	"./square/tv.svg": 1983,
	"./square/tw.svg": 1984,
	"./square/tz.svg": 1985,
	"./square/ua.svg": 1986,
	"./square/ug.svg": 1987,
	"./square/um.svg": 1988,
	"./square/un.svg": 1989,
	"./square/us.svg": 1990,
	"./square/uy.svg": 1991,
	"./square/uz.svg": 1992,
	"./square/va.svg": 1993,
	"./square/vc.svg": 1994,
	"./square/ve.svg": 1995,
	"./square/vg.svg": 1996,
	"./square/vi.svg": 1997,
	"./square/vn.svg": 1998,
	"./square/vu.svg": 1999,
	"./square/wf.svg": 2000,
	"./square/ws.svg": 2001,
	"./square/xk.svg": 2002,
	"./square/xx.svg": 2003,
	"./square/ye.svg": 2004,
	"./square/yt.svg": 2005,
	"./square/za.svg": 2006,
	"./square/zm.svg": 2007,
	"./square/zw.svg": 2008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1742;